import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import "../styles/EditarBLModal.css";
//import '../styles/ListaPedidos.css';
import { fetchWithAuth, API_URL } from "../Componentes/fetchWithAuth";

const EditarBLModal = ({ isOpen, onClose, initialData, t = {} }) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (initialData) {
      const processedData = {
        id_bl: initialData.id_bl || "",
        nroBL: initialData.nroBL || "",
        idNaviera: initialData.idNaviera || "",
        id_importador: initialData.idImportador || "",
        Puertodecarga: initialData.NombrePuertoCarga || "",
        Puertodedestino: initialData.idPuertosDestino || "",
        FechaEmision: initialData.FechaEmision
          ? new Date(initialData.FechaEmision)
          : null,
        BLOriginal: initialData.BLOriginal ?? 0,
        Description: initialData.Description || "",
        id_NotifyParty: initialData.id_NotifyParty || "",
        id_Consignee: initialData.id_Consignee || "",
        idPuertosCarga: initialData.NombrePuertoCarga || "",
        idPuertosDestino: initialData.idPuertosDestino || "",
        id_shipper: initialData.idShipper || "",
        NavieraSelected: null,
        ImportadorSelected: null,
        ShipperSelected: null,
        NotifyPartySelected: null,
        ConsigneeSelected: null,
        PuertosCargaSelected: null,
        PuertosDestinoSelected: null,
      };
      setFormData(processedData);
      // [EXPERT_COMMENT]: Eliminación de inicialización temprana - Se eliminó la inicialización de originalFormData aquí para evitar problemas de sincronización con los datos asíncronos.
    }
  }, [initialData]);

  // [EXPERT_COMMENT]: Nuevo useEffect para inicializar originalFormData después de la carga de datos asíncronos - Asegura que originalFormData refleje el estado completo del formulario.

  const [importadores, setImportadores] = useState([]);
  const [shippers, setShippers] = useState([]); // [EXPERT_COMMENT]: Nuevo estado - Almacena la lista de Shippers para el nuevo dropdown.
  const [navieras, setNavieras] = useState([]);
  const [notifyParties, setNotifyParties] = useState([]); // [EXPERT_COMMENT]: Estado para Notify Parties - Se añadió para almacenar la lista de Notify Parties.
  const [consignees, setConsignees] = useState([]); // [EXPERT_COMMENT]: Estado para Consignees - Se añadió para almacenar la lista de Consignees.
  const [puertosCarga, setPuertosCarga] = useState([]); // [EXPERT_COMMENT]: Estado para Puertos de Carga - Se añadió para almacenar la lista de puertos de carga.
  const [puertosDestino, setPuertosDestino] = useState([]); // [EXPERT_COMMENT]: Estado para Puertos de Destino - Se añadió para almacenar la lista de puertos de destino.
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Cargar importadores
  useEffect(() => {
    const fetchImportadores = async () => {
      if (!isOpen) return;
      try {
        const response = await fetchWithAuth(`${API_URL}/api/importador`); // [EXPERT_COMMENT]: Corrección de URL - Se cambió a `/api/importador` para obtener los datos correctos.
        const data = await response.json();
        setImportadores(Array.isArray(data) ? data : []); // [EXPERT_COMMENT]: Validación de tipo de datos - Asegura que 'data' sea un array antes de actualizar el estado para evitar errores en el Dropdown.

        // [EXPERT_COMMENT]: Buscar y seleccionar Importador inicial - Se busca por ID o por nombre.
        let selectedImportador = null; // [EXPERT_COMMENT]: Inicialización de variable para el importador seleccionado.
        if (initialData?.idImportador) {
          // [EXPERT_COMMENT]: Prioridad de búsqueda por ID.
          selectedImportador = data.find(
            (imp) =>
              imp.id_importador?.toString() ===
              initialData.idImportador?.toString(),
          );
        }
        if (!selectedImportador && initialData?.Importador) {
          // [EXPERT_COMMENT]: Búsqueda por nombre si el ID no encontró un match.
          selectedImportador = data.find(
            (imp) =>
              imp.nombreimportador?.toString() ===
              initialData.Importador?.toString(),
          );
        }
        if (selectedImportador) {
          // [EXPERT_COMMENT]: Si se encontró un importador, se actualiza el estado.
          setFormData((prev) => ({
            ...prev,
            id_importador: selectedImportador.id_importador, // [EXPERT_COMMENT]: Actualiza el ID del importador en formData.
            ImportadorSelected: selectedImportador, // [EXPERT_COMMENT]: Asigna el objeto Importador seleccionado.
          }));
        }
      } catch (err) {
        setError(err.message);
      }
    };
    // [EXPERT_COMMENT]: Eliminación de dependencia cíclica - Se eliminó 'importadores' del array de dependencias para evitar un bucle infinito de recarga de datos.
    // [EXPERT_COMMENT]: Eliminación de dependencia de traducción - Se eliminó 't.error' ya que no es una dependencia directa para la carga de datos y puede causar re-ejecuciones innecesarias.
    fetchImportadores();
  }, [isOpen, initialData?.idImportador, initialData?.Importador]);

  // [EXPERT_COMMENT]: Cargar Shippers (nuevo campo) - Efecto para obtener la lista de Shippers desde la API.
  useEffect(() => {
    const fetchShippers = async () => {
      if (!isOpen) return; // [EXPERT_COMMENT]: Condición de ejecución - Solo se ejecuta si el modal está abierto.
      try {
        const response = await fetchWithAuth(`${API_URL}/api/shippers`); // [EXPERT_COMMENT]: Llamada a la API - Obtiene los shippers.
        const data = await response.json(); // [EXPERT_COMMENT]: Parseo de respuesta - Convierte la respuesta a JSON.
        setShippers(Array.isArray(data) ? data : []); // [EXPERT_COMMENT]: Validación de tipo de datos - Asegura que 'data' sea un array antes de actualizar el estado.

        // [EXPERT_COMMENT]: Buscar y seleccionar Shipper inicial - Se busca por ID o por nombre.
        let selectedShipper = null; // [EXPERT_COMMENT]: Inicialización de variable para el shipper seleccionado.
        if (initialData?.idShipper) {
          // [EXPERT_COMMENT]: Prioridad de búsqueda por ID.
          selectedShipper = data.find(
            (shipper) =>
              shipper.idshipper?.toString() ===
              initialData.idShipper?.toString(),
          );
        }
        if (!selectedShipper && initialData?.Shipper) {
          selectedShipper = data.find(
            (shipper) =>
              shipper.nombreshipper?.toString() ===
              initialData.Shipper?.toString(),
          );
        }
        if (selectedShipper) {
          setFormData((prev) => ({
            ...prev,
            id_shipper: selectedShipper.idshipper,
            ShipperSelected: selectedShipper,
          }));
        }
      } catch (err) {
        setError(err.message);
      }
    };
    fetchShippers();
  }, [isOpen, initialData?.idShipper, initialData?.Shipper]);

  // [EXPERT_COMMENT]: Cargar navieras - Efecto para obtener la lista de navieras desde la API.
  useEffect(() => {
    const fetchNavieras = async () => {
      if (!isOpen) return; // [EXPERT_COMMENT]: Condición de ejecución - Solo se ejecuta si el modal está abierto.
      try {
        const response = await fetchWithAuth(`${API_URL}/api/navieras`); // [EXPERT_COMMENT]: Llamada a la API - Obtiene las navieras.
        const data = await response.json(); // [EXPERT_COMMENT]: Parseo de respuesta - Convierte la respuesta a JSON.
        setNavieras(Array.isArray(data) ? data : []); // [EXPERT_COMMENT]: Validación de tipo de datos - Asegura que 'data' sea un array antes de actualizar el estado para evitar errores en el Dropdown.

        // [EXPERT_COMMENT]: Buscar y seleccionar naviera inicial - Si hay un idNaviera en initialData.
        if (initialData?.idNaviera) {
          const selected = data.find(
            (nav) =>
              nav.id_naviera?.toString() === initialData.idNaviera?.toString(), // [EXPERT_COMMENT]: Acceso seguro a propiedad - Usa optional chaining.
          ); // [EXPERT_COMMENT]: Búsqueda de la naviera.
          setFormData((prev) => ({
            ...prev, // [EXPERT_COMMENT]: Mantiene los datos previos del formulario.
            NavieraSelected: selected, // [EXPERT_COMMENT]: Asigna el objeto naviera seleccionado.
          })); // [EXPERT_COMMENT]: Cierre de objeto de actualización de estado.
        } // [EXPERT_COMMENT]: Cierre de bloque if.
      } catch (err) {
        setError(err.message); // [EXPERT_COMMENT]: Manejo de error - Almacena el mensaje de error.
      } // [EXPERT_COMMENT]: Cierre de bloque catch.
    }; // [EXPERT_COMMENT]: Cierre de función fetchNavieras.
    fetchNavieras(); // [EXPERT_COMMENT]: Ejecución de la función de carga.
  }, [isOpen, initialData?.idNaviera]); // [EXPERT_COMMENT]: Eliminación de dependencia cíclica y de traducción - Se eliminó 'navieras' y 't.error' del array de dependencias.

  // [EXPERT_COMMENT]: Cargar Notify Parties - Nuevo efecto para obtener la lista de Notify Parties.
  useEffect(() => {
    const fetchNotifyParties = async () => {
      if (!isOpen) return; // [EXPERT_COMMENT]: Condición de ejecución - Solo se ejecuta si el modal está abierto.
      try {
        const response = await fetchWithAuth(`${API_URL}/api/notify`); // [EXPERT_COMMENT]: Llamada a la API - Se cambió la ruta a `/api/notify` para obtener los datos correctos.
        const data = await response.json();
        setNotifyParties(Array.isArray(data) ? data : []);

        if (initialData?.id_NotifyParty) {
          const selected = data.find(
            (np) =>
              np.id_NotifyParty?.toString() ===
              initialData.id_NotifyParty?.toString(),
          );
          if (!selected) {
            console.warn(
              "[EXPERT_COMMENT]: EditarBLModal - No se encontró Notify Party con el ID:",
              initialData.id_NotifyParty,
            );
          }
          setFormData((prev) => ({
            ...prev,
            NotifyPartySelected: selected,
          }));
        }
      } catch (err) {
        setError(err.message);
      }
    };
    fetchNotifyParties();
  }, [isOpen, initialData?.id_NotifyParty]);

  // [EXPERT_COMMENT]: Cargar Consignees - Nuevo efecto para obtener la lista de Consignees.
  useEffect(() => {
    const fetchConsignees = async () => {
      if (!isOpen) return; // [EXPERT_COMMENT]: Condición de ejecución - Solo se ejecuta si el modal está abierto.
      try {
        const response = await fetchWithAuth(`${API_URL}/api/consigneer`); // [EXPERT_COMMENT]: Corrección de URL - Se cambió `/api/consignee` a `/api/consigneer` para coincidir con la ruta del backend.
        const data = await response.json(); // [EXPERT_COMMENT]: Parseo de respuesta - Convierte la respuesta a JSON.
        setConsignees(Array.isArray(data) ? data : []);

        const selected = data.find(
          (con) =>
            (initialData.id_Consignee &&
              con.id_Consignee?.toString() ===
                initialData.id_Consignee?.toString()) ||
            (initialData.NombreConsignee &&
              con.NombreConsignee?.toString() ===
                initialData.NombreConsignee?.toString()),
        );
        if (
          !selected &&
          (initialData.id_Consignee || initialData.NombreConsignee)
        ) {
          console.warn(
            "[EXPERT_COMMENT]: EditarBLModal - No se encontró Consignee con el ID/Nombre:",
            initialData.id_Consignee || initialData.NombreConsignee,
          );
        }
        setFormData((prev) => ({
          ...prev,
          ConsigneeSelected: selected,
        }));
      } catch (err) {
        setError(err.message);
      }
    };
    fetchConsignees();
  }, [isOpen, initialData?.id_Consignee, initialData?.NombreConsignee]);

  // [EXPERT_COMMENT]: Cargar Puertos de Carga - Nuevo efecto para obtener la lista de Puertos de Carga.
  useEffect(() => {
    const fetchPuertosCarga = async () => {
      if (!isOpen) return; // [EXPERT_COMMENT]: Condición de ejecución - Solo se ejecuta si el modal está abierto.
      try {
        const response = await fetchWithAuth(`${API_URL}/api/puertosdecarga`); // [EXPERT_COMMENT]: Llamada a la API - Obtiene los puertos de carga.
        const data = await response.json(); // [EXPERT_COMMENT]: Parseo de respuesta - Convierte la respuesta a JSON.
        // [EXPERT_COMMENT]: Validación de tipo de datos - Asegura que 'data' sea un array antes de actualizar el estado para evitar errores en el Dropdown.
        setPuertosCarga(Array.isArray(data) ? data : []);

        const selected = data.find(
          (p) =>
            initialData.NombrePuertoCarga &&
            p.NombrePuertoOrigen?.toString() ===
              initialData.NombrePuertoCarga?.toString(),
        );
        if (!selected && initialData.NombrePuertoCarga) {
          console.warn(
            "[EXPERT_COMMENT]: EditarBLModal - No se encontró Puerto de Carga con el Nombre:",
            initialData.NombrePuertoCarga,
          );
        }
        setFormData((prev) => ({
          ...prev,
          PuertosCargaSelected: selected,
        }));
      } catch (err) {
        setError(err.message);
      }
    };
    fetchPuertosCarga();
  }, [isOpen, initialData?.Puertodecarga, initialData?.NombrePuertoCarga]);

  // [EXPERT_COMMENT]: Cargar Puertos de Destino - Nuevo efecto para obtener la lista de Puertos de Destino.
  useEffect(() => {
    const fetchPuertosDestino = async () => {
      if (!isOpen) return;
      try {
        const response = await fetchWithAuth(`${API_URL}/api/puertosdestino`);
        const data = await response.json();
        setPuertosDestino(Array.isArray(data) ? data : []);

        if (initialData?.idPuertosDestino) {
          const selected = data.find((p) => {
            return (
              p.idPuertoDestino?.toString() ===
              initialData.idPuertosDestino?.toString()
            );
          });
          if (!selected) {
            console.warn(
              "[EXPERT_COMMENT]: EditarBLModal - No se encontró Puerto de Destino con el ID:",
              initialData.idPuertosDestino,
            );
          }
          setFormData((prev) => ({
            ...prev,
            PuertosDestinoSelected: selected,
          }));
        }
      } catch (err) {
        setError(err.message);
      }
    };
    fetchPuertosDestino();
  }, [isOpen, initialData?.idPuertosDestino]);

  // EditarBLModal.jsx - Sincronización final de formData con initialData y objetos seleccionados.

  // Handlers
  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    setLoading(true);
    setError(null);

    try {
      // Estructura que espera el backend
      // [EXPERT_COMMENT]: Validación de ID de BL - Asegura que el ID del BL no sea una cadena vacía antes de enviar la solicitud de edición.
      if (!formData.id_bl) {
        throw new Error(
          t.errorIdBLVacio || "El ID del Bill of Lading no puede estar vacío.",
        ); // [EXPERT_COMMENT]: Lanzamiento de error - Si el ID es vacío, se lanza un error con un mensaje descriptivo.
      }

      const dataToSend = {
        id_bl: formData.id_bl, // [EXPERT_COMMENT]: Mantiene el ID del BL.
        nroBL: formData.nroBL, // [EXPERT_COMMENT]: Mantiene el número de BL.
        id_importador: formData.ImportadorSelected?.id_importador || null, // [EXPERT_COMMENT]: Mantiene el ID del Importador existente.
        id_shipper: formData.ShipperSelected?.idshipper || null, // [EXPERT_COMMENT]: Corrección de propiedad - Se envía `idshipper` del objeto seleccionado al backend.
        //nombreImportador: formData.ImportadorSelected?.nombreImportador || "", // Nombre textual
        Puertodecarga: formData.PuertosCargaSelected?.idPuertosOrigen || null, // [EXPERT_COMMENT]: Envío de ID de Puerto de Carga - Se asegura que se envíe el ID numérico del puerto de carga.
        Puertodedestino:
          formData.PuertosDestinoSelected?.idPuertoDestino || null, // [EXPERT_COMMENT]: Corrección de propiedad - Se envía el ID correcto del puerto de destino ('idPuertoDestino') para guardar en la base de datos.
        Description: formData.Description,
        FechaEmision: formData.FechaEmision?.toISOString(), // Formato ISO
        BLOriginal: formData.BLOriginal,
        id_Consignee: formData.ConsigneeSelected?.id_Consignee || null, // [EXPERT_COMMENT]: Se añadió el ID del Consignee seleccionado, corrigiendo la propiedad.
        id_NotifyParty: formData.NotifyPartySelected?.id_NotifyParty || null, // [EXPERT_COMMENT]: Se añadió el ID de la Notify Party seleccionada, corrigiendo la propiedad.
        idNaviera: formData.NavieraSelected?.id_naviera || null, // [EXPERT_COMMENT]: Se corrigió para enviar el id_naviera del objeto seleccionado.
        idPuertosCarga: formData.PuertosCargaSelected?.idPuertosOrigen || null, // [EXPERT_COMMENT]: Corrección de propiedad - Se cambió `idPuertosCarga` a `idPuertosOrigen` para coincidir con la API.
        idPuertosDestino:
          formData.PuertosDestinoSelected?.idPuertoDestino || null, // [EXPERT_COMMENT]: Corrección de propiedad - Se envía el ID correcto del puerto de destino ('idPuertoDestino') para el backend.
        //Nombrenaviera: formData.NavieraSelected?.Nombrenaviera || 0
      };
      const response = await fetchWithAuth(
        `${API_URL}/api/editarbl/${dataToSend.id_bl}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataToSend),
        },
      );
      //console.log("Esta es la respuesta que se pretende enviar:", dataToSend, "a esta url", `${servidor}/api/editarbl/${dataToSend.id_bl}`);
      //console.log("JSON Creado:", dataToSend);
      //console.log("ID BL:", dataToSend.id_bl);

      if (!response.ok) throw new Error(t.errorGuardar || "Error al guardar");
      //console.log("Info pa enviar:", dataToSend);

      //onClose(true);
      handleClose("success");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (result) => {
    // Resetea formData combinando valores iniciales con initialData
    setFormData({
      nroBL: "",
      idNaviera: 0,
      id_importador: "", // [EXPERT_COMMENT]: Reseteo de campo.
      ImportadorSelected: null, // [EXPERT_COMMENT]: Reseteo de campo.
      id_shipper: "", // [EXPERT_COMMENT]: Nuevo campo - Reseteo del ID del nuevo Shipper.
      ShipperSelected: null, // [EXPERT_COMMENT]: Nuevo campo - Reseteo del objeto seleccionado para el nuevo Shipper.
      NavieraSelected: null, // [EXPERT_COMMENT]: Reseteo de campo.
      NotifyPartySelected: null, // [EXPERT_COMMENT]: Reseteo de campo.
      ConsigneeSelected: null, // [EXPERT_COMMENT]: Reseteo de campo.
      Puertodecarga: "", // [EXPERT_COMMENT]: Reseteo de campo - Se mantiene como Puerto de Carga.
      PuertosCargaSelected: null, // [EXPERT_COMMENT]: Reseteo de campo - Se añadió para Puerto de Carga.
      Puertodedestino: "", // [EXPERT_COMMENT]: Reseteo de campo - Se añadió para Puerto de Destino.
      PuertosDestinoSelected: null, // [EXPERT_COMMENT]: Reseteo de campo - Se añadió para Puerto de Destino.
      FechaEmision: null, // [EXPERT_COMMENT]: Reseteo de campo.
      BLOriginal: 0, // [EXPERT_COMMENT]: Reseteo de campo.
      id_NotifyParty: "", // [EXPERT_COMMENT]: Reseteo de campo.
      id_Consignee: "", // [EXPERT_COMMENT]: Reseteo de campo.
      idPuertosCarga: "", // [EXPERT_COMMENT]: Reseteo de campo - Se añadió para Puerto de Carga.
      idPuertosDestino: "", // [EXPERT_COMMENT]: Reseteo de campo - Se añadió para Puerto de Destino.
      Description: "", // [EXPERT_COMMENT]: Reseteo de campo.
      ...initialData, // [EXPERT_COMMENT]: Aplica los datos iniciales actualizados.
    }); // [EXPERT_COMMENT]: Cierre de objeto de estado.
    onClose(result === "success"); // [EXPERT_COMMENT]: Llama a la función onClose del padre.
  };

  const handleDropdownChange = (e, type) => {
    if (type === "Naviera") {
      setFormData((prev) => ({
        ...prev,
        idNaviera: e.value.id_naviera,
        NavieraSelected: e.value,
      }));
    } else if (type === "importador") {
      setFormData((prev) => ({
        ...prev,
        id_importador: e.value.id_importador, // [EXPERT_COMMENT]: Corrección de propiedad - Se cambió `id_Importador` a `id_importador`.
        ImportadorSelected: e.value,
      }));
    } else if (type === "shipper") {
      // [EXPERT_COMMENT]: Nuevo manejador - Para el dropdown del nuevo Shipper.
      setFormData((prev) => ({
        ...prev,
        id_shipper: e.value.idshipper, // [EXPERT_COMMENT]: Corrección de propiedad - Se asigna `idshipper` del valor seleccionado.
        ShipperSelected: e.value, // [EXPERT_COMMENT]: Asigna el objeto Shipper seleccionado.
      }));
    } else if (type === "notifyParty") {
      // [EXPERT_COMMENT]: Manejador para Notify Party - Nuevo bloque para manejar el cambio en el dropdown de Notify Party.
      setFormData((prev) => ({
        ...prev,
        id_NotifyParty: e.value.id_NotifyParty, // [EXPERT_COMMENT]: Asigna el ID de la Notify Party, corrigiendo la propiedad.
        NotifyPartySelected: e.value,
      }));
    } else if (type === "consignee") {
      // [EXPERT_COMMENT]: Manejador para Consignee - Nuevo bloque para manejar el cambio en el dropdown de Consignee.
      setFormData((prev) => ({
        ...prev,
        id_Consignee: e.value.id_Consignee, // [EXPERT_COMMENT]: Asigna el ID del Consignee, corrigiendo la propiedad.
        ConsigneeSelected: e.value,
      }));
    } else if (type === "puertosCarga") {
      // [EXPERT_COMMENT]: Manejador para Puertos de Carga.
      setFormData((prev) => ({
        ...prev,
        idPuertosCarga: e.value.idPuertosOrigen, // [EXPERT_COMMENT]: Corrección de propiedad - Se cambió `idPuertosCarga` a `idPuertosOrigen` para coincidir con la API.
        Puertodecarga: e.value.NombrePuertoOrigen, // [EXPERT_COMMENT]: Corrección de propiedad - Se cambió `NombrePuertoCarga` a `NombrePuertoOrigen` para coincidir con la API.
        PuertosCargaSelected: e.value,
      }));
    } else if (type === "puertosDestino") {
      // [EXPERT_COMMENT]: Manejador para Puertos de Destino.
      console.log(
        "[EXPERT_COMMENT]: Dropdown PuertosDestino cambiado. e.value:",
        e.value,
      ); // [EXPERT_COMMENT]: Log de depuración - Muestra el objeto seleccionado en el dropdown de Puertos de Destino.
      setFormData((prev) => ({
        ...prev,
        idPuertosDestino: e.value.idPuertoDestino, // [EXPERT_COMMENT]: Corrección de propiedad - Se cambió `e.value.idPuertosDestino` a `e.value.idPuertoDestino` para coincidir con la estructura de datos real.
        Puertodedestino: e.value.idPuertoDestino, // [EXPERT_COMMENT]: Corrección de propiedad - Se cambió `e.value.idPuertosDestino` a `e.value.idPuertoDestino` para coincidir con la estructura de datos real.
        PuertosDestinoSelected: e.value,
      }));
    }
  };

  return (
    <Dialog
      header={t.titulo || "Editar BL"}
      visible={isOpen}
      modal
      onHide={onClose}
      className="modal-bl"
      closeOnEscape={!loading}
    >
      <div className="grid-container">
        {/* Columna 1 */}
        <div className="grid-column">
          <div className="field">
            <label>{t.campos?.nroBL || "Número BL"}</label>
            <InputText
              id="editar-bl-nrobl"
              value={formData.nroBL || ""}
              onChange={handleTextChange}
              name="nroBL"
              autoComplete="off"
              disabled={loading}
            />
          </div>

          <div className="field">
            <label>{t.campos?.idNaviera || "ID Naviera"}</label>
            <Dropdown
              id="editar-bl-naviera-dropdown"
              value={formData.NavieraSelected}
              options={navieras ?? []} // [EXPERT_COMMENT]: Manejo de opciones nulas - Asegura que options siempre sea un array.
              optionLabel="Nombrenaviera"
              onChange={(e) => handleDropdownChange(e, "Naviera")}
              placeholder={t.seleccione || "Seleccione"}
              filter
              className="w-full"
            />
            {error && <small className="p-error">{error}</small>}
          </div>

          <div className="field">
            <label>{t.campos?.idImportador || "Importador"}</label>
            <Dropdown
              id="editar-bl-importador-dropdown"
              value={formData.ImportadorSelected}
              options={importadores ?? []} // [EXPERT_COMMENT]: Manejo de opciones nulas - Asegura que options siempre sea un array.
              optionLabel="nombreimportador" // [EXPERT_COMMENT]: Corrección de propiedad - Se muestra `nombreimportador` en el dropdown.
              onChange={(e) => handleDropdownChange(e, "importador")}
              placeholder={t.seleccione || "Seleccione"}
              filter
              className="w-full"
            />
            {error && <small className="p-error">{error}</small>}
          </div>

          <div className="field">
            <label>{t.campos?.idShipper || "Shipper"}</label>
            <Dropdown
              id="editar-bl-shipper-dropdown"
              value={formData.ShipperSelected} // [EXPERT_COMMENT]: Nuevo campo - Valor del dropdown del nuevo Shipper.
              options={shippers ?? []} // [EXPERT_COMMENT]: Nuevo campo - Opciones del dropdown del nuevo Shipper.
              optionLabel="nombreshipper" // [EXPERT_COMMENT]: Corrección de propiedad - Se muestra `nombreshipper` en el dropdown.
              onChange={(e) => handleDropdownChange(e, "shipper")} // [EXPERT_COMMENT]: Nuevo manejador - Llama al manejador para el nuevo Shipper.
              placeholder={t.seleccione || "Seleccione"}
              filter
              className="w-full"
            />
            {error && <small className="p-error">{error}</small>}
          </div>

          <div className="field">
            <label>{t.campos?.Puertodecarga || "Puerto de Carga"}</label>
            <Dropdown
              id="editar-bl-puerto-carga-dropdown"
              value={formData.PuertosCargaSelected}
              options={puertosCarga ?? []} // [EXPERT_COMMENT]: Manejo de opciones nulas - Asegura que options siempre sea un array.
              optionLabel="NombrePuertoOrigen" // [EXPERT_COMMENT]: Corrección de propiedad - Se cambió `NombrePuertoCarga` a `NombrePuertoOrigen` para coincidir con la API.
              onChange={(e) => handleDropdownChange(e, "puertosCarga")}
              placeholder={t.seleccione || "Seleccione"}
              filter
              className="w-full"
            />
            {error && <small className="p-error">{error}</small>}
          </div>
        </div>

        {/* Columna 2 */}
        <div className="grid-column">
          <div className="field">
            <label>{t.campos?.Puertodedestino || "Puerto de Destino"}</label>
            <Dropdown
              id="editar-bl-puerto-destino-dropdown"
              value={formData.PuertosDestinoSelected}
              options={puertosDestino ?? []} // [EXPERT_COMMENT]: Manejo de opciones nulas - Asegura que options siempre sea un array.
              optionLabel="NombrePuertoDestino"
              onChange={(e) => handleDropdownChange(e, "puertosDestino")}
              placeholder={t.seleccione || "Seleccione"}
              filter
              className="w-full"
            />
            {error && <small className="p-error">{error}</small>}
          </div>
          <div className="field">
            <label>{t.campos?.FechaEmision || "Fecha Emisión"}</label>
            <Calendar
              id="editar-bl-fecha-emision"
              value={formData.FechaEmision}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, FechaEmision: e.value }))
              }
              showTime
              hourFormat="24"
              dateFormat="dd/mm/yy"
              className="calendar-full-width"
              showButtonBar
              readOnlyInput
              disabled={loading}
              onClose={(e) => e.target.focus()}
            />
          </div>

          <div className="field checkbox-field">
            <div className="checkbox-container">
              <Checkbox
                inputId="editar-bl-original"
                checked={formData.BLOriginal === 1}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    BLOriginal: e.checked ? 1 : 0,
                  }))
                }
                disabled={loading}
              />
              <label htmlFor="editar-bl-original" className="checkbox-label">
                {t.campos?.BLOriginal || "BL Original"}
              </label>
            </div>
          </div>
          <div className="field">
            <label>{t.campos?.idNotifyParty || "Notify Party"}</label>
            <Dropdown
              id="editar-bl-notify-party-dropdown"
              value={formData.NotifyPartySelected}
              options={notifyParties ?? []} // [EXPERT_COMMENT]: Manejo de opciones nulas - Asegura que options siempre sea un array.
              optionLabel="NombreNotifyParty"
              onChange={(e) => handleDropdownChange(e, "notifyParty")}
              placeholder={t.seleccione || "Seleccione"}
              filter
              className="w-full"
            />
            {error && <small className="p-error">{error}</small>}
          </div>

          <div className="field">
            <label>{t.campos?.idConsignee || "Consignee"}</label>
            <Dropdown
              id="editar-bl-consignee-dropdown"
              value={formData.ConsigneeSelected}
              options={consignees ?? []} // [EXPERT_COMMENT]: Manejo de opciones nulas - Asegura que options siempre sea un array.
              optionLabel="NombreConsignee"
              onChange={(e) => handleDropdownChange(e, "consignee")}
              placeholder={t.seleccione || "Seleccione"}
              filter
              className="w-full"
            />
            {error && <small className="p-error">{error}</small>}
          </div>

          <div className="field">
            <label>{t.campos?.Description || "Descripción"}</label>
            <InputTextarea
              id="editar-bl-descripcion"
              value={formData.Description || ""}
              onChange={handleTextChange}
              name="Description"
              rows={3}
              autoComplete="off"
              disabled={loading}
            />
          </div>
        </div>
      </div>

      <div className="p-dialog-footer">
        <Button
          id="btn-editar-bl-guardar"
          label={t.guardarbutton || "Guardar"}
          icon="pi pi-check"
          className="p-button-success"
          onClick={handleSave}
          loading={loading}
          onClose={handleClose}
        />
        <Button
          id="btn-editar-bl-cancelar"
          label={t.cancelarbutton || "Cancelar"}
          icon="pi pi-times"
          className="p-button-secondary"
          onClick={onClose}
          disabled={loading}
          //onClick={handleClose}
        />
      </div>
    </Dialog>
  );
};

export default EditarBLModal;
